export const userQuestionAuthorId = '00120bdc-ab54-2abc-7dd7-5af05c43bb59';


// WEBPACK FOOTER //
// ./src/app/tradingstudio/utils/constants.ts